import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import InvoiceConfirmDialog from '../molecules/InvoiceConfirmDialog';

const styles = {
  button: {
    margin: '5px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(
  ({
    classes,
    openConfirm,
    updateOpenConfirm,
    onClickAction,
    message,
    monthInvoice,
    disabled
  }) => {
    const cancelAction = () => updateOpenConfirm(false);
    return (
      <>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={() => updateOpenConfirm(true)}
          disabled={disabled}
        >
          {message}
        </Button>
        <InvoiceConfirmDialog
          openConfirm={openConfirm}
          updateOpenConfirm={updateOpenConfirm}
          cancelAction={cancelAction}
          confirmAction={onClickAction}
          target=""
          monthInvoice={monthInvoice}
        />
      </>
    );
  }
);

export default withStyles(styles)(button);
